module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"button.discardDraft":"Elimina bozza","button.sendOffer":"Invia Proposta","offerDeleted":"Proposta cancellata","cannotSendOffer":"Errore durante l\u0027invio  della proposta","offerSent":"Proposta inviata con successo","confirmSendTitle":"Confermo invio","confirmSendText":"Sei sicuro di voler inviare la proposta?","approvalLink":"Link per Approvazione"}}')
  delete Component.options._Ctor
}
